/**
 * In preview iframe we need to get the parent customize instance instead
 * the own one, because the API differs.
 */ function getSidebarCustomize(allowParentWindow) {
    if (allowParentWindow === void 0) allowParentWindow = true;
    var _window_parent, _window, _window1;
    return allowParentWindow && ((_window = window) == null ? void 0 : (_window_parent = _window.parent) == null ? void 0 : _window_parent.wp.customize) || ((_window1 = window) == null ? void 0 : _window1.wp.customize);
}
export { getSidebarCustomize };
